var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between align-center"
  }, [_c('div', [_vm._v(" Príjem "), _c('span', {
    staticClass: "pop-800"
  }, [_vm._v(_vm._s(_vm.summaryData.clientInfo.type.toLowerCase()) + "a")]), _vm._v(" z "), _c('span', {
    staticClass: "pop-800"
  }, [_vm._v("sro")])]), _c('div', [_c('img', {
    staticClass: "activate-button nav-link-icon filter-primary",
    "class": {
      'rotate': _vm.opened
    },
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg",
      "alt": ""
    },
    on: {
      "click": function click($event) {
        _vm.opened = !_vm.opened;
      }
    }
  })])]), _c('v-expand-transition', {
    staticClass: "summary-items-transition"
  }, [_vm.opened ? _c('div', {
    staticClass: "summary-items-wrapper"
  }, [_c('text-value-holder', {
    attrs: {
      "label": 'typ príjmu',
      "value": _vm.summaryData.typ
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'druh príjmu',
      "value": 'SRO'
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'mesačný príjem',
      "value": _vm.summaryData.dti.extra.prijem_mo
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'obchodný názov',
      "value": _vm.summaryData.zamestnavatel.name
    }
  }), _c('div', {
    staticClass: "text-small light fullwidth"
  }, [_vm._v(" Viac údajov na "), _c('a', {
    "class": [_vm.summaryData.zamestnavatel.ico ? 'link pointer' : 'link pointer noselect'],
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.navigateToFinstat.apply(null, arguments);
      }
    }
  }, [_vm._v(" finstat.sk ")])]), _c('text-value-holder', {
    attrs: {
      "label": 'ičo',
      "value": _vm.summaryData.zamestnavatel.ico
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'obec',
      "value": _vm.summaryData.zamestnavatel.address_city
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'ulica',
      "value": _vm.summaryData.zamestnavatel.address_street
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'súpisné číslo',
      "value": _vm.summaryData.zamestnavatel.address_popisne
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'orientačné číslo',
      "value": _vm.summaryData.zamestnavatel.address_number
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'PSČ',
      "value": _vm.summaryData.zamestnavatel.address_zip
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'podiel v spoločnosti',
      "value": _vm.summaryData.podiel_v_sro
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'odvetvie',
      "value": _vm.summaryData.zamestnavatel_odvetvie
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'komora',
      "value": _vm.summaryData.komora
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'podnikám od',
      "value": _vm.transformDate(_vm.summaryData.zamestnanie_od)
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'zisk',
      "value": _vm.summaryData.zisk_sro
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'tržby',
      "value": _vm.summaryData.minulorocny_obrat
    }
  })], 1) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }